export class ReserveAUnit {
  daysReservationIsValid: number;
  daysAReservationCanBeMadeInAdvance: number;
  useDatePicker?= false;
  useFutureStartDate?= false;
  disableDays?: boolean[];
  futureStartDate?: Date;
  useShortMoveInForm = false;
  followUpDay = 'immediately';

  constructor() {
    this.daysReservationIsValid = 7;
    this.daysAReservationCanBeMadeInAdvance = 3;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/reserveAUnit.ts